import StatusBadge from "./StatusBadge";
import { formatDeadline, formatDateTime } from "../complaintApi";
import "./complaintManagement.css";

const ComplaintTable = ({ complaints, onView, loading }) => {
  return (
    <div className="campaign-table-section">
      <table className="custom-table-v3">
        <thead>
          <tr>
            <th>Event ID</th>
            <th>Order ID</th>
            <th>Type</th>
            <th>Subject</th>
            <th>Status</th>
            <th>Deadline</th>
            <th>Created At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="8">
                <div className="table-no-record-section">Loading...</div>
              </td>
            </tr>
          ) : complaints?.length ? (
            complaints.map((row) => (
              <tr key={row.id}>
                <td className="text-warp">{row.ctripEventId}</td>
                <td>{row.ctripPurchaseOrderId}</td>
                <td>
                  <span
                    className={`cmp-type-tag ${
                      row.eventType === "Penalty"
                        ? "cmp-type-penalty"
                        : "cmp-type-service"
                    }`}
                  >
                    {row.eventType}
                  </span>
                </td>
                <td>{row.subject}</td>
                <td>
                  <StatusBadge status={row.status} />
                </td>
                <td>{formatDeadline(row.deadline)}</td>
                <td>{formatDateTime(row.createdAt)}</td>
                <td>
                  <button
                    type="button"
                    className="cmp-view-btn"
                    onClick={() => onView(row)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">
                <div className="table-no-record-section">
                  No records are found.
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ComplaintTable;
